import React from "react";
import type { SpinnerAppearance } from "./SpinnerAppearance.ts";
import { ControlledSpinner } from "./internal/ControlledSpinner.tsx";
import {
  type LoadingState,
  useSuccessSpinnerState,
} from "./internal/useSuccessSpinnerState.ts";

export interface Props extends SpinnerAppearance {
  /** `loading` (spinning), `error` (X icon), or `success` — plays the checkmark, then renders nothing. */
  state?: LoadingState;
}

/**
 * Loading indicator with animated states. Supports `loading`, `success`, and `error` states for async operation feedback.
 */
export const Spinner: React.FC<Props> = ({ state = "loading", ...props }) => (
  <ControlledSpinner {...props} {...useSuccessSpinnerState(state)} />
);

export { type LoadingState } from "./internal/useSuccessSpinnerState.ts";
